import {Injectable} from '@angular/core';
import {Http, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs';
import {LiquidityAccounts, LiquidityAccountsInPool} from '../entity';

@Injectable()
export class LiquidityAccountsService {

    constructor(private http: Http) {
    }

    getLiquidityAccountsByPool(poolId: number): Observable<LiquidityAccounts> {
        return this.http
            .get(LiquidityAccountsService.prepareAccountsByPoolURL(poolId))
            .map(response => response.json());
    }

    getLiquidityAccountsByPoolAndCurrency(poolId: number, currencyId: number): Observable<LiquidityAccounts> {
        let search: URLSearchParams = new URLSearchParams();
        search.set('currency', String(currencyId));

        return this.http
            .get(LiquidityAccountsService.prepareAccountsByPoolURL(poolId), {search: search})
            .map(response => response.json());
    }

    getAppropriateLiquidityAccountsDependOnBalanceForOutgoingTransferGroupedByPools(transferPaymentId: number): Observable<LiquidityAccountsInPool[]> {
        return this.http.get(`/api/backoffice/transfers/outgoing/${transferPaymentId}/liquidity-accounts`)
            .map(response => response.json())
            .map(json => json.data);
    }

    updateLiquidityAccountForNewOutgoingTransfer(transferPaymentId: number, oldLiquidityAccountId: number, newLiquidityAccountId: number): Observable<any> {
        return this.http.patch(`/api/backoffice/transfers/outgoing/${transferPaymentId}/liquidity-accounts`,
            {value_current: oldLiquidityAccountId, value_new: newLiquidityAccountId})
            .map(response => response.json());
    }

    private static prepareAccountsByPoolURL(id: number): string {
        return `/api/backoffice/pools/${id}/liquidity_accounts`;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/liquidity_account.service.ts